import { colorsJson } from './colorsChartBars';
import { GraphColors } from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';

export const getColorsChartBarsJson = (idx: number): GraphColors => {
  return idx + 1 <= colorsJson.length
    ? (colorsJson[idx] as GraphColors)
    : { variant: 'secondary-05', tone: '900' };
};
